var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iconType == 'fontawesome')?_c('i',{staticClass:"fa",class:'fa-'+_vm.icon},[_vm._v(" ")]):(_vm.iconType == 'image')?_c('img',{attrs:{"width":"32px","src":_vm.icon}}):(_vm.iconType == 'iconclass')?_c('i',{class:_vm.icon},[_vm._v(" ")]):(_vm.iconType == 'remix')?_c('i',{class:_vm.icon},[_vm._v(" ")]):_c('span')
}
var staticRenderFns = []

export { render, staticRenderFns }